// Mantine theme color tokens assigned to chart series in order, so that charts
// with several series get distinct, theme-aware colors without repeating a
// palette in every file.
export const chartPalette = [
    'blue.6', 'teal.6', 'orange.6', 'grape.6', 'red.6',
    'cyan.6', 'lime.6', 'pink.6', 'indigo.6', 'yellow.6',
];
